import { useTranslation } from 'react-i18next';

import IncidentListRenderer from '@/components/Incidents/incident-list-renderer';
import OtherRelatedIncidents from '@/components/Incidents/other-related-incidents';
import StatusMessage from '@/components/shared/status-message';
import { useGetIncidentsByStop } from '@/hooks/use-get-incidents-by-stop';
import { useRelatedIncidents } from '@/hooks/use-related-incidents';
import { ERROR_FEEDBACK } from '@/utils/constants';

const StationIncidentsList = ({ stationId }: { stationId: string }) => {
  const { t } = useTranslation();

  const {
    data: stationIncidents = [],
    isLoading,
    isError,
    refetch,
  } = useGetIncidentsByStop(stationId);

  const { filteredMatchedIncidents, filteredOtherRelatedIncidents, isEmpty } =
    useRelatedIncidents(stationIncidents);

  if (isError) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center py-8">
        <StatusMessage
          type="error"
          title={t(ERROR_FEEDBACK.general)}
          description={t(ERROR_FEEDBACK.incidents.api)}
          showReloadButton
          onRetry={refetch}
        />
      </div>
    );
  }

  return (
    <div className="pt-2 h-full">
      <IncidentListRenderer data={filteredMatchedIncidents} isLoading={isLoading} isEmpty={isEmpty}>
        {!isLoading && <OtherRelatedIncidents incidents={filteredOtherRelatedIncidents} />}
      </IncidentListRenderer>
    </div>
  );
};

export default StationIncidentsList;
